import { createVfm, useVfm } from 'vue-final-modal';

export default defineNuxtPlugin(nuxtApp => {
  const vfm = createVfm();
  const vfmModal = useVfm();

  nuxtApp.vueApp.use(vfm);
  nuxtApp.provide('modal', vfmModal);
});
